import { PureComponent } from "react";
import enhanceWithClickOutside from "react-click-outside";
import DropDown from "basicComponents/DropDown/DropDown";
import * as PropTypes from "prop-types";

class AutosaveDropDown extends PureComponent {
  state = {};

  handleClickOutside() {
    this.props.onConfirm();
  }

  render() {
    return <DropDown {...this.props} />;
  }
}

AutosaveDropDown.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  ...DropDown.propTypes,
};

export default enhanceWithClickOutside(AutosaveDropDown);
